module.exports = __webpack_public_path__ + "static/img/M-600-JAVA-GLOW.f46575d.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-600-JAVA-GLOW.png
// module id = TPbY
// module chunks = 0